import { getEventBusIfDefined } from '@cian/event-bus';
import { Store } from 'redux';
import { IApplicationState } from '../../../../shared/types/redux';

export function createRenderCallback(store: Store<IApplicationState>) {
  const eventBus = getEventBusIfDefined();

  return () => {
    if (eventBus) {
      eventBus.emit('metrics-loader', {
        type: 'unlock-initialization',
      });
    }
  };
}
